import blackbishop from "../img/blackBishop.png";
import blackking from "../img/blackKing.png";
import blackknight from "../img/blackKnight.png";
import blackpawn from "../img/blackPawn.png";
import blackqueen from "../img/blackQueen.png";
import blackrook from "../img/blackRook.png";
import whitebishop from "../img/whiteBishop.png";
import whiteking from "../img/whiteKing.png";
import whiteknight from "../img/whiteKnight.png";
import whitepawn from "../img/whitePawn.png";
import whitequeen from "../img/whiteQueen.png";
import whiterook from "../img/whiteRook.png";

import blackbishopcrappy from "../img/blackBishopCrappy.png";
import blackkingcrappy from "../img/blackKingCrappy.png";
import blackknightcrappy from "../img/blackKnightCrappy.png";
import blackpawncrappy from "../img/blackPawnCrappy.png";
import blackqueencrappy from "../img/blackQueenCrappy.png";
import blackrookcrappy from "../img/blackRookCrappy.png";
import whitebishopcrappy from "../img/whiteBishopCrappy.png";
import whitekingcrappy from "../img/whiteKingCrappy.png";
import whiteknightcrappy from "../img/whiteKnightCrappy.png";
import whitepawncrappy from "../img/whitePawnCrappy.png";
import whitequeencrappy from "../img/whiteQueenCrappy.png";
import whiterookcrappy from "../img/whiteRookCrappy.png";

import blackbishoptriangle from "../img/blackBishopTriangle.png";
import blackkingtriangle from "../img/blackKingTriangle.png";
import blackknighttriangle from "../img/blackKnightTriangle.png";
import blackpawntriangle from "../img/blackPawnTriangle.png";
import blackqueentriangle from "../img/blackQueenTriangle.png";
import blackrooktriangle from "../img/blackRookTriangle.png";
import whitebishoptriangle from "../img/whiteBishopTriangle.png";
import whitekingtriangle from "../img/whiteKingTriangle.png";
import whiteknighttriangle from "../img/whiteKnightTriangle.png";
import whitepawntriangle from "../img/whitePawnTriangle.png";
import whitequeentriangle from "../img/whiteQueenTriangle.png";
import whiterooktriangle from "../img/whiteRookTriangle.png";

const images = {
  blackbishop,
  blackking,
  blackknight,
  blackpawn,
  blackqueen,
  blackrook,
  whitebishop,
  whiteking,
  whiteknight,
  whitepawn,
  whitequeen,
  whiterook,

  blackbishopcrappy,
  blackkingcrappy,
  blackknightcrappy,
  blackpawncrappy,
  blackqueencrappy,
  blackrookcrappy,
  whitebishopcrappy,
  whitekingcrappy,
  whiteknightcrappy,
  whitepawncrappy,
  whitequeencrappy,
  whiterookcrappy,

  blackbishoptriangle,
  blackkingtriangle,
  blackknighttriangle,
  blackpawntriangle,
  blackqueentriangle,
  blackrooktriangle,
  whitebishoptriangle,
  whitekingtriangle,
  whiteknighttriangle,
  whitepawntriangle,
  whitequeentriangle,
  whiterooktriangle,
};

export default images;